import gql from 'graphql-tag';

export const UserProfileFragment = gql`
  fragment UserProfileFragment on UserDetails {
    firstName
    lastName
    email
    sex
    icon
  }
`;

export const EducationProfileFragment = gql`
  fragment EducationProfileFragment on EducationProfile {
    educationYear
    school
    schoolId
    province
    grade
    major
    interSchool
  }
`;

export const ShortMockExamStudentProfileFragment = gql`
  fragment ShortMockExamStudentProfileFragment on MockExamStudentProfile {
    id
    firstName
    lastName
    studentCode
    locationName
  }
`;

export const MockExamStudentProfileFragment = gql`
  fragment MockExamStudentProfileFragment on MockExamStudentProfile {
    id
    firstName
    lastName
    studentCode
    ssid
    phone
    major
    email
    roundCode
    locationName
    locationCode
    departmentId
    enabledExamCardControl
  }
`;
